module.exports = __webpack_public_path__ + "static/img/teacher_chose.653a3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/register/teacher_chose.png
// module id = sQHS
// module chunks = 1